import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=46d7abac&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=46d7abac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d7abac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46d7abac')) {
      api.createRecord('46d7abac', component.options)
    } else {
      api.reload('46d7abac', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=46d7abac&scoped=true&", function () {
      api.rerender('46d7abac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2GaoUVQkB0sxi/JS/comp/CookieBox.vue"
export default component.exports